import { render, staticRenderFns } from "./DuplicateItem.vue?vue&type=template&id=e3ee22ec&scoped=true"
import script from "./DuplicateItem.vue?vue&type=script&lang=js"
export * from "./DuplicateItem.vue?vue&type=script&lang=js"
import style0 from "./DuplicateItem.vue?vue&type=style&index=0&id=e3ee22ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3ee22ec",
  null
  
)

export default component.exports